import TradelineGroupRow from './TradelineGroupRow'

import React, { useMemo } from 'react'

import { useUpdateTradelineMutation } from '@/services/tradeline'

const TradelinesGroups = ({ groupedTradelines, sortConfig, application }) => {
  const [updateTradeline, { isLoading: isUpdatingTradeline }] = useUpdateTradelineMutation()

  const tradelineGroups = useMemo(() => {
    return Object.keys(groupedTradelines).map((tradelineType) => {
      const unpaidBalanceAmount = groupedTradelines[tradelineType].reduce(
        (acc, current) => (acc += parseFloat(current.unpaid_balance_amount) || 0),
        0
      )
      const monthlypaymentAmount = groupedTradelines[tradelineType].reduce((acc, current) => {
        if (current.monthly_payment_amount)
          return (acc += parseFloat(current.monthly_payment_amount) || 0)
        else return acc
      }, 0)

      const PMTRate = (monthlypaymentAmount / unpaidBalanceAmount) * 100

      return {
        account_type: tradelineType,
        unpaid_balance_amount: unpaidBalanceAmount,
        monthly_payment_amount: monthlypaymentAmount,
        pmt_ratio: PMTRate,
        tradelines: groupedTradelines[tradelineType],
      }
    })
  }, [groupedTradelines])

  const sortedRows = React.useMemo(() => {
    const mortgageGroup = tradelineGroups?.filter((group) => group.account_type === 'mortgage')
    let toBeSorted = tradelineGroups?.filter((group) => group.account_type !== 'mortgage')

    const helocGroup = toBeSorted?.filter((group) => group.account_type === 'heloc')
    toBeSorted = toBeSorted?.filter((group) => group.account_type !== 'heloc')

    const solarGroup = toBeSorted?.filter((group) => group.account_type === 'solar')
    toBeSorted = toBeSorted?.filter((group) => group.account_type !== 'solar')

    toBeSorted.sort((a, b) => a.account_type.localeCompare(b.account_type))

    return [...mortgageGroup, ...helocGroup, ...solarGroup, ...toBeSorted]
  }, [sortConfig, tradelineGroups])

  return (
    <>
      {sortedRows?.map((group) => (
        <TradelineGroupRow
          key={group.account_type}
          group={group}
          application={application}
          sortConfig={sortConfig}
          updateTradeline={updateTradeline}
          isUpdatingTradeline={isUpdatingTradeline}
        />
      ))}
    </>
  )
}

export default TradelinesGroups
